import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import React, { useEffect, useState } from 'react';

import Dialog from './dialog';
import AddAddress from './add-address';
import AddEmail from './add-email';
import AddName from './add-name';
import axios from 'axios';
import { useFormValue } from '../../context';

const steps = ['address', 'email', 'name'];

const GetOffer = () => {
  const { formStore, setFormStore } = useFormValue();
  const [current, setCurrent] = useState([0, steps[0]]);

  const [waiting, setWaiting] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    type: 'warning',
    message: '',
  });
  const [submitFinal, setSubmitFinal] = useState(false);

  const AlertMessage = ({ message }) => (
    <Alert
      borderRadius="md"
      status={message.type}
    >
      <Flex justifyContent="space-between">
        <AlertIcon />
        <AlertTitle mr={2} />
        <AlertDescription>{message.message}</AlertDescription>
        <CloseIcon
          onClick={() => setAlertMessage({ type: 'warning', message: '' })}
          ml={4}
        />
      </Flex>
    </Alert>
  );
  const handleNext = () => {
    if (current[0] !== steps.length - 1) {
      setCurrent((prev) => [prev[0] + 1, steps[prev[0] + 1]]);
    }
  };
  const handleBack = () => {
    if (current[0] !== 0) {
      setCurrent((prev) => [prev[0] - 1, steps[prev[0] - 1]]);
    }
  };

  const onSubmitAll = async () => {
    setWaiting(true);
    console.log('submit all', formStore);
    const results = await axios
      .post(
        // 'https://hooks.zapier.com/hooks/catch/6894175/b2jx6m3/',
        JSON.stringify(formStore),
      )
      .then((res) => {
        console.log(res);
        setWaiting(false);
        if (res.status === 200) {
          setAlertMessage({
            type: 'success',
            message: 'Thank you, we will be in touch you shortly.',
          });
          return 200;
        }
        if (res.status === 401) {
          setAlertMessage({
            type: 'warning',
            message:
              'We already have your info. If you think we missed you, please call 510-900-8770',
          });
          return 401;
        }
      })
      .catch((err) => {
        setWaiting(false);
        setAlertMessage({
          type: 'error',
          message:
            "Something went wrong. Please try again and if that doesn't work please call 510-900-8770",
        });
      });
    return results;
  };

  const onSubmit = () => {
    if (current[0] === steps.length - 1) {
      setSubmitFinal(true);
    }
  };

  useEffect(() => {
    console.log('formStore', formStore);
    console.log('submit', submitFinal);
    if (submitFinal) {
      console.log('ran');
      onSubmitAll();
    }
  }, [formStore, submitFinal]);

  return (
    <Box
      rounded="md"
      p={5}
      backgroundColor="white"
      // boxShadow="xl"
      width={{
        base: '90vw',
        sm: '80vw',
        md: '80vw',
        lg: 'auto',
      }}
    >
      <Box display={{ base: 'none', md: 'block' }}>
        <Heading
          as="h2"
          size="xl"
          lineHeight="base"
          mb={0}
          maxWidth="600px"
        >
          Get Your All Cash Offer Started
        </Heading>
      </Box>
      <Box display={{ base: 'auto', md: 'none' }}>
        <Heading
          as="h2"
          size="lg"
          lineHeight="base"
          mb={0}
          maxWidth="600px"
        >
          Get Your All Cash Offer Started
        </Heading>
      </Box>
      <Box className="get-offer">
        <Box>
          <Text color="grey.300">
            Step
            {' '}
            {current[0] + 1}
            {' '}
            of
            {' '}
            {steps.length}
          </Text>
        </Box>
        <Box height="100%">
          {current[1] === 'address' ? (
            <AddAddress
              onSubmit={onSubmit}
              formStore={formStore}
              handleNext={handleNext}
              handleBack={handleBack}
              handleSubmitAll={onSubmitAll}
            />
          ) : (
            <div />
          )}
          {current[1] === 'email' ? (
            <AddEmail
              onSubmit={onSubmit}
              formStore={formStore}
              handleNext={handleNext}
              handleBack={handleBack}
            />
          ) : (
            <div />
          )}
          {current[1] === 'name' ? (
            <AddName
              onSubmit={onSubmit}
              formStore={formStore}
              handleNext={handleNext}
              handleBack={handleBack}
              handleWait={waiting}
            />
          ) : (
            <div />
          )}
          {/* {current[1] === 'dialog' ? (
            <Dialog
              waiting={waiting}
              alertMessage={alertMessage}
              setAlertMessage={setAlertMessage}
            />
          ) : (
            <div />
          )} */}
        </Box>
      </Box>
      <Box
        minheight="50px"
        mt={6}
      >
        {alertMessage.message !== '' ? (
          <AlertMessage
            backgroundColor="transparent"
            message={alertMessage}
          />
        ) : undefined}
      </Box>
    </Box>
  );
};

export default GetOffer;
